import { gapi } from "gapi-script";

let isGoogleAuthInitialized = false;

export const initializeGoogleAuth = async () => {
  if (!isGoogleAuthInitialized) {
    try {
      await gapi.client.init({
        clientId: process.env.REACT_APP_GOOGLE_CLIENT,
        scope: "email profile https://www.googleapis.com/auth/user.phonenumbers.read https://www.googleapis.com/auth/contacts.readonly",
      });
      isGoogleAuthInitialized = true;
      console.log("Google API client initialized");
    } catch (error) {
      console.error("Error initializing Google API client:", error);
      throw error;
    }
  } else {
    console.log("Google API client already initialized");
  }
};
